import React from "react";

import { Info } from "lucide-react";

type WorkspacePlaceholderCardProps = {
  title: string;
  className?: string;
  minHeight?: string;
};

export const ComingSoonContent: React.FC = () => (
  <div className="relative flex h-full min-h-[120px] w-full items-center justify-center overflow-hidden rounded-lg">
    <div className="absolute inset-0 overflow-hidden rounded-lg" aria-hidden>
      <div className="absolute -left-3 top-2 size-16 rounded-full bg-[#FECACA]/60 blur-2xl" />
      <div className="absolute -right-2 top-0 size-[4.5rem] rounded-full bg-[#BBF7D0]/60 blur-2xl" />
      <div className="absolute inset-0 bg-white/70 backdrop-blur-md" />
    </div>

    <div className="relative z-10 mx-3 flex flex-col items-center rounded-xl border border-[#EBEBEB] bg-white px-8 py-5 text-center shadow-[0_1px_3px_rgba(0,0,0,0.06)]">
      <Info
        className="mb-2.5 size-7 shrink-0 text-[#FF9500]"
        strokeWidth={1.75}
        aria-hidden
      />
      <p className="m-0 text-[15px] font-semibold leading-5 text-[#6B7280]">
        Coming Soon!
      </p>
      <p className="m-0 mt-1 text-xs font-normal leading-4 text-[#9F9F9F]">
        Stay tuned for updates
      </p>
    </div>
  </div>
);

const WorkspacePlaceholderCard: React.FC<WorkspacePlaceholderCardProps> = ({
  title,
  className = "",
  minHeight = "min-h-[140px]",
}) => (
  <section
    className={`box-border flex w-full min-w-0 flex-col rounded-lg border border-[#EBEBEB] bg-white px-4 pb-3 pt-3.5 ${minHeight} ${className}`}
  >
    <h2 className="m-0 text-base font-bold text-black">{title}</h2>
    <hr className="m-0 mb-3 mt-3 w-full border-0 border-t border-[#F6F6F6]" />

    <div className="relative flex min-h-0 flex-1 overflow-hidden">
      <ComingSoonContent />
    </div>
  </section>
);

export default WorkspacePlaceholderCard;
